// Tiny client-side store of share tokens the viewer has visited.
// Used so divers can install the PWA and have a "saved schedules" home screen.
const KEY = 'jd-viewer-shares';
const NAME_KEY = 'jd-viewer-claimed-names'; // { share_token: diver_name }

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (e) {
    return [];
  }
};

const write = (arr) => {
  try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, 25))); } catch (e) { /* ignore */ }
};

const readNames = () => {
  try {
    const raw = localStorage.getItem(NAME_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

const writeNames = (obj) => {
  try { localStorage.setItem(NAME_KEY, JSON.stringify(obj)); } catch (e) { /* ignore */ }
};

export const viewerStore = {
  list: () => read(),
  add: ({ token, trip_name, date }) => {
    if (!token) return;
    const now = Date.now();
    const existing = read().filter((s) => s.token !== token);
    write([{ token, trip_name: trip_name || 'Dive schedule', date: date || '', last_seen: now }, ...existing]);
  },
  remove: (token) => {
    write(read().filter((s) => s.token !== token));
    // Also forget any claimed name for that share.
    const names = readNames();
    delete names[token];
    writeNames(names);
  },
  clear: () => { write([]); writeNames({}); },
  hasAny: () => read().length > 0,

  // Claimed-name helpers — used by Diver "My Logged Dives" feature.
  claimedName: (token) => readNames()[token] || null,
  claimName: (token, name) => {
    const obj = readNames();
    if (name) obj[token] = name;
    else delete obj[token];
    writeNames(obj);
  },
  // Returns the most-recently-set claimed name (for default-suggesting across shares).
  lastClaimedName: () => {
    const obj = readNames();
    const all = Object.values(obj);
    return all.length ? all[all.length - 1] : null;
  },
};
